import { MbscEventcalendarView } from '@mobiscroll/react';
import useQueryParams from './useQueryParams';
import { useWorkplacesContext } from 'module/workplaces/context/WorkplacesContext';
import { getDayNumber } from 'shared/utils/dates';

type CalendarView = 'week' | 'day' | 'workweek' | 'month';

export const getCalendarConfig = (
	view: CalendarView,
	firstDayOfWeek: number = 1
): MbscEventcalendarView => {
	switch (view) {
		case 'month': {
			return {
				calendar: {
					type: 'month',
				},
			};
		}
		case 'day': {
			return {
				timeline: {
					type: 'month',
					timeCellStep: 60,
					timeLabelStep: 60,
					rowHeight: 'variable',
				},
			};
		}
		case 'workweek': {
			return {
				timeline: {
					type: 'month',
					eventList: false, // Disable event list to show time-based events
					startDay: firstDayOfWeek,
					endDay: firstDayOfWeek - 1 || 0,
					timeCellStep: 240,
					timeLabelStep: 240,
					rowHeight: 'variable',
				},
			};
		}
		case 'week':
		default: {
			return {
				timeline: {
					type: 'week',
					eventList: false, // Disable event list to show time-based events
					startDay: firstDayOfWeek,
					endDay: firstDayOfWeek - 1 || 0,
					timeCellStep: 240,
					timeLabelStep: 240,
					rowHeight: 'variable',
				},
			};
		}
	}
};

export const useCalendarView = (startOfWeek = '0') => {
	const { query, change } = useQueryParams();
	const { workplace: _workplace } = useWorkplacesContext();
	// console.log("here is workplace", workplace);

	const calendarView = (query.time || 'day') as CalendarView;

	const setCalendarView = (view: CalendarView) => {
		change({ time: view });
	};

	const calendarConfig = getCalendarConfig(
		calendarView,
		// getDayNumber(workplace.first_day_of_the_week)
		getDayNumber(+startOfWeek)
	);

	return { calendarView, calendarConfig, setCalendarView };
};
